<template>
  <div class="audioRecorderMain">
    <div v-show="isUploading" class="isLoadingInfo">
      Yükleniyor
    </div>

    <a @click.prevent="cancelRecord" class="cancelAudio" href="" v-show="!isUploading">
      <img src="@/assets/images/cancelaudio.png" style="width:30px" />
    </a>
    <div class="audioDurationCircle" v-show="!isUploading">
      ⬤
    </div>
    <div class="audioDuration" v-show="!isUploading">
      {{ minuteSecond }}
    </div>
    <a @click.prevent="submitRecord" class="submitAudio" href="" v-show="!isUploading">
      <img src="@/assets/images/submitaudio.png" style="width:30px" />
    </a>

    <div style="display: none">
      <audio ref="audioPlayer" controls playsinline />
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import * as RecordRTC from 'recordrtc'
import EventBus from '@/eventbus.js'
require('@/security.js')
var moment = require('moment')

export default {
  mixins: [messageMixin],

  data() {
    return {
      isEdge: navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob),
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      recorder: undefined,
      audio: undefined,
      microphone: undefined,
      uploadFileObj: {},
      isUploading: false,
      minute: 0,
      second: 1
    }
  },
  computed: {
    minuteSecond() {
      var str = '0' + this.minute.toString() + ':'
      if (this.second) {
        str += '0'
      }
      return str + this.second.toString()
    }
  },
  methods: {
    cancelRecord() {
      this.recorder.stopRecording()
      this.releaseMicrophone()
      this.$store.dispatch('toggleAudioRecorderState')
    },

    submitRecord() {
      this.isUploading = true
      this.recorder.stopRecording(this.stopRecordingCallback)
      setTimeout(() => {
        this.uploadRecording()
        this.releaseMicrophone()
      }, 1000)
    },
    toggleTimer() {
      this.interval = setInterval(this.incrementTime, 1000)
    },
    incrementTime() {
      if (this.second > 59) {
        this.minute = parseInt(this.minute) + 1
      }
      this.second %= 60
      this.second = parseInt(this.second) + 1
    },
    startRecording() {
      if (!this.microphone) {
        this.captureMicrophone(mic => {
          this.microphone = mic

          if (this.isSafari) {
            this.replaceAudio()

            this.audio.muted = true
            this.audio.srcObject = this.microphone

            alert('Please click startRecording button again. First time we tried to access your this.microphone. Now we will record it.')
            return
          }
          this.toggleTimer()
          this.startRecording()
        })
        return
      }

      this.replaceAudio()

      this.audio.muted = true
      this.audio.srcObject = this.microphone

      var options = {
        type: 'audio',
        disableLogs: true,
        numberOfAudioChannels: this.isEdge ? 1 : 2,
        checkForInactiveTracks: true,
        bufferSize: 16384
      }

      if (this.isSafari || this.isEdge) {
        options.this.recorderType = RecordRTC.StereoAudioRecorder
      }

      if (
        navigator.platform &&
        navigator.platform
          .toString()
          .toLowerCase()
          .indexOf('win') === -1
      ) {
        options.sampleRate = 48000 // or 44100 or remove this line for default
      }

      if (this.isSafari) {
        options.sampleRate = 44100
        options.bufferSize = 4096
        options.numberOfAudioChannels = 2
      }

      if (this.recorder) {
        this.recorder.destroy()
        this.recorder = null
      }

      this.recorder = RecordRTC(this.microphone, options)
      // this.toggleTimer()
      this.recorder.startRecording()
    },

    releaseMicrophone(ev) {
      if (this.microphone) {
        this.microphone.stop()
        this.microphone = null
      }
    },

    uploadRecording() {
      if (!this.recorder) return

      if (!this.recorder.getBlob()) return

      /*
                      if (this.isSafari) {
                        this.recorder.getDataURL(function (dataURL) {
                          this.SaveToDisk(dataURL, this.getFileName('wav'))
                        })
                        return
                      }
                      */

      var blob = this.recorder.getBlob()
      var file = new File([blob], this.getFileName('wav'), {
        type: 'audio/wav'
      })

      this.uploadFileObj = JSON.parse(JSON.stringify(this.$store.state.message.uploadFileModel))
      this.uploadFileObj.file = file
      this.uploadFileObj.processId = this.$uuid.v4()
      this.uploadFileObj.uploadUrl = process.env.VUE_APP_UPLOADURL

      EventBus.$emit('heyManagerUploadThisFile', this.uploadFileObj, 'audioFileUploaded')

      // this.invokeSaveAsDialog(file)
    },

    click(el) {
      var evt = document.createEvent('Event')
      evt.initEvent('click', true, true)
      el.dispatchEvent(evt)
    },

    getRandomString() {
      if (window.crypto && window.crypto.getRandomValues && navigator.userAgent.indexOf('Safari') === -1) {
        var a = window.crypto.getRandomValues(new Uint32Array(3))
        var token = ''
        for (var i = 0, l = a.length; i < l; i++) {
          token += a[i].toString(36)
        }
        return token
      } else {
        return (Math.random() * new Date().getTime()).toString(36).replace(/\./g, '')
      }
    },
    getFileName(fileExtension) {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var date = d.getDate()
      return 'RecordRTC-' + year + month + date + '-' + this.getRandomString() + '.' + fileExtension
    },

    SaveToDisk(fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement('a')
        save.href = fileURL
        save.download = fileName || 'unknown'
        save.style = 'display:none;opacity:0;color:transparent;'
        ;(document.body || document.documentElement).appendChild(save)

        if (typeof save.click === 'function') {
          save.click()
        } else {
          save.target = '_blank'
          var event = document.createEvent('Event')
          event.initEvent('click', true, true)
          save.dispatchEvent(event)
        }

        ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
      } else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, '_blank')
        _window.document.close()
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close()
      }
    },

    captureMicrophone(callback) {
      if (this.microphone) {
        callback(this.microphone)
        return
      }

      if (typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
        alert('This browser does not supports WebRTC getUserMedia API.')

        if (navigator.getUserMedia) {
          alert('This browser seems supporting deprecated getUserMedia API.')
        }
      }

      navigator.mediaDevices
        .getUserMedia({
          audio: this.isEdge
            ? true
            : {
                echoCancellation: false
              }
        })
        .then(function(mic) {
          callback(mic)
        })
        .catch(function(error) {
          alert('Unable to capture your this.microphone. Please check console logs.')
          console.error(error)
        })
    },

    replaceAudio(src) {
      var newAudio = document.createElement('audio')
      newAudio.controls = true
      newAudio.autoplay = true

      if (src) {
        newAudio.src = src
      }

      var parentNode = this.audio.parentNode
      parentNode.innerHTML = ''
      parentNode.appendChild(newAudio)

      this.audio = newAudio
    },

    stopRecordingCallback() {
      this.replaceAudio(URL.createObjectURL(this.recorder.getBlob()))

      /*
          setTimeout(function () {
            if (!vm.audio.paused) return

                      setTimeout(function () {
                        if (!vm.audio.paused) return
                        // vm.audio.play()
                      }, 1000)

            // vm.audio.play()
          }, 300)

            // this.audio.play()
            */

      if (this.isSafari) {
        this.releaseMicrophone()
      }
    },

    invokeSaveAsDialog(file, fileName) {
      if (!file) {
        console.log('Blob object is required.')
      }

      if (!file.type) {
        try {
          file.type = 'video/webm'
        } catch (e) {}
      }

      var fileExtension = (file.type || 'video/webm').split('/')[1]

      if (fileName && fileName.indexOf('.') !== -1) {
        var splitted = fileName.split('.')
        fileName = splitted[0]
        fileExtension = splitted[1]
      }

      var fileFullName = (fileName || Math.round(Math.random() * 9999999999) + 888888888) + '.' + fileExtension

      if (typeof navigator.msSaveOrOpenBlob !== 'undefined') {
        return navigator.msSaveOrOpenBlob(file, fileFullName)
      } else if (typeof navigator.msSaveBlob !== 'undefined') {
        return navigator.msSaveBlob(file, fileFullName)
      }

      var hyperlink = document.createElement('a')
      hyperlink.href = URL.createObjectURL(file)
      hyperlink.download = fileFullName

      hyperlink.style = 'display:none;opacity:0;color:transparent;'
      ;(document.body || document.documentElement).appendChild(hyperlink)

      if (typeof hyperlink.click === 'function') {
        hyperlink.click()
      } else {
        hyperlink.target = '_blank'
        hyperlink.dispatchEvent(
          new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          })
        )
      }

      URL.revokeObjectURL(hyperlink.href)
    },

    uploadManagerUploadedFile() {
      this.addAudioMessageFromMe([this.uploadFileObj.resultURL])
    },

    addAudioMessageFromMe(mediaURLS) {
      var newMsg = JSON.parse(JSON.stringify(this.$store.state.conversation.activeConversation.newMessage))
      newMsg.MessageID = this.$uuid.v4()
      newMsg.CreateDate =
        moment()
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.UpdateDate =
        moment()
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.From = this.$store.state.session.user.UserID
      if (this.$store.state.conversation.activeConversation.isGroupConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.GroupID
        newMsg.ConversationID = ''
        newMsg.isGroup = true
        newMsg.ConversationType = 1
      } else if (this.$store.state.conversation.activeConversation.isChannelConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.ChannelID
        newMsg.ConversationID = ''
        newMsg.isGroup = false
        newMsg.ConversationType = 2
      } else {
        newMsg.To = this.$store.state.conversation.activeConversation.ContactID
        newMsg.ConversationID = this.$store.state.conversation.activeConversation.ConversationID
        newMsg.ConversationType = 0
      }
      newMsg.MessageType = 8
      newMsg.MediaURLs = mediaURLS
      newMsg.Body = ''
      newMsg.DeleteStatus = 0

      if (this.$store.state.ien) {
        this.$set(newMsg, 'mv', 2) // encryption update
        this.em(newMsg)
      }

      this.$store.dispatch('appendMessages', [newMsg])
      this.$store.dispatch('clearActiveNewMessage')

      this.sendMessage(newMsg)

      this.$store.dispatch('toggleAudioRecorderState')
    }
  },

  mounted() {
    this.audio = this.$refs.audioPlayer

    this.startRecording()
  },

  created() {
    EventBus.$on('audioFileUploaded', this.uploadManagerUploadedFile)
  },

  beforeDestroy() {
    EventBus.$off('audioFileUploaded')
  }
}
</script>

<style lang="less" scoped>
.isLoadingInfo {
  animation: blinker 1.5s linear infinite;
  text-align: center;
  color: red;
  font-weight: 700;
  width: 100%;
}

.audioRecorderMain {
  width: 200px;
  transition: 0.3s;
  display: flex;
  align-items: center;
}

.cancelAudio,
.submitAudio {
  padding: 10px;
}

.audioDuration {
  flex-grow: 1;
  text-align: center;
}

.audioDurationCircle {
  flex-grow: 1;
  text-align: right;
  color: rgb(165, 1, 1);
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
